module.exports = __webpack_public_path__ + "static/ssrp_logo-adcf19ad194c607b9ff390f04b1dd299.svg";